import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'components/core/Button';
import { SFIcon } from 'components/core/SFIcon';

export function DotControl({ index, onClick, slideShowing }) {
	const handleClick = useCallback(() => onClick(index), [index, onClick]);
	return (
		<li className="dot">
			<Button
				onClick={handleClick}
				primary={false}
			>
				<SFIcon icon={`${slideShowing ? 'circle' : 'circle-o'}`} />
			</Button>
		</li>
	);
}

DotControl.propTypes = {
	index: PropTypes.number,
	onClick: PropTypes.func,
	slideShowing: PropTypes.bool,
};
export default DotControl;
